import FormsyInput from '@components/Textfield/withFormsy'
import { withTranslate } from '@i18n/utils'
import featureToggles from 'shared/featureToggles'

const PhoneInput = ({ value, translate: t }) => (
    <FormsyInput
        id="phone"
        value={value}
        name="phone"
        pattern="^[\d ]*$"
        validations={{
            matchRegexp: /^[\d]*$/,
            ...(featureToggles.caPurchaseFlow && { minLength: 10, maxLength: 10 }),
        }}
        label={t('dashboard.account.phone')}
        validationError={t('dashboard.account.phone.invalid')}
        autoComplete="tel"
        required
    />
)

export default withTranslate(PhoneInput)
